var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "24px",
    viewBox: "0 0 38 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Master-card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEEZ_PSP_UI_Icons",
    transform: "translate(-163.000000, -235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master-card",
    transform: "translate(163.000000, 235.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#CED0DA",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 23,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(6.000000, 4.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF5F00",
    x: 9.10397143,
    y: 1.71063422,
    width: 7.71034603,
    height: 12.5773755
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89814152,8.00043286 C9.89620555,5.54650079 11.0241298,3.22795732 12.9569199,1.71285598 C9.67341371,-0.864372507 4.95816715,-0.48897689 2.12492878,2.57522488 C-0.708309594,5.63942665 -0.708309594,10.3636608 2.12492878,13.4278626 C4.95816715,16.4920644 9.67341371,16.86746 12.9569199,14.2902315 C11.0235148,12.774649 9.89552157,10.4551446 9.89814152,8.00043286 Z",
    id: "Path",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1514078,12.9641291 L25.1514078,12.7006442 L25.2638254,12.7006442 L25.2638254,12.6461301 L24.9962715,12.6461301 L24.9962715,12.7006442 L25.101944,12.7006442 L25.101944,12.9641291 L25.1514078,12.9641291 Z M25.6707771,12.9641291 L25.6707771,12.6461301 L25.5898364,12.6461301 L25.4954056,12.8732723 L25.4009748,12.6461301 L25.3200342,12.6461301 L25.3200342,12.9641291 L25.3784913,12.9641291 L25.3784913,12.7233584 L25.466177,12.9300578 L25.5268825,12.9300578 L25.6145683,12.7233584 L25.6145683,12.9641291 L25.6707771,12.9641291 Z",
    id: "Shape",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9150173,8.00043286 C25.9150173,11.0627673 24.164155,13.8562443 21.4062123,15.1944637 C18.6482697,16.532683 15.3673684,16.1807025 12.9569199,14.2880097 C14.8888666,12.7716221 16.0168758,10.4533869 16.0168758,7.99932198 C16.0168758,5.54525706 14.8888666,3.22702184 12.9569199,1.71063422 C15.3673684,-0.182058574 18.6482697,-0.534039037 21.4062123,0.804180284 C24.164155,2.14239961 25.9150173,4.93587669 25.9150173,7.9982111 L25.9150173,8.00043286 Z",
    id: "Path",
    fill: "#F79E1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ms_vrt_pos",
    transform: "translate(5.405060, 2.386311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    transform: "translate(0.000000, -0.000000)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.bc60355b.svg";
export { ForwardRef as ReactComponent };